import { useState } from "react";
import { motion } from "framer-motion";
import { useAuth } from "../../context/AuthContext";

const NotesManager = ({ userData }) => {
  const { addNote } = useAuth();
  const [newNote, setNewNote] = useState({
    title: "",
    content: "",
  });
  const [showNoteForm, setShowNoteForm] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewNote((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    addNote(newNote);
    setNewNote({
      title: "",
      content: "",
    });
    setShowNoteForm(false);
  };

  return (
    <div className="notes-manager">
      <div className="section-header">
        <h2>Notes</h2>
        <motion.button
          className="add-button"
          onClick={() => setShowNoteForm(!showNoteForm)}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {showNoteForm ? "Cancel" : "+ Add Note"}
        </motion.button>
      </div>

      {showNoteForm && (
        <motion.div
          className="note-form"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
        >
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Title</label>
              <input
                type="text"
                name="title"
                value={newNote.title}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Content</label>
              <textarea
                name="content"
                value={newNote.content}
                onChange={handleInputChange}
                required
                rows="5"
              />
            </div>
            <motion.button
              type="submit"
              className="save-button"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
            >
              Save Note
            </motion.button>
          </form>
        </motion.div>
      )}

      <div className="notes-grid">
        {userData?.notes?.length > 0 ? (
          userData.notes.map((note) => (
            <motion.div
              key={note.id}
              className="note-card"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <h3>{note.title}</h3>
              <div className="note-content">
                {note.content.split("\n").map((paragraph, i) => (
                  <p key={i}>{paragraph}</p>
                ))}
              </div>
              <div className="note-meta">
                <small>
                  Last updated:{" "}
                  {new Date(note.lastUpdated).toLocaleDateString()}
                </small>
              </div>
            </motion.div>
          ))
        ) : (
          <div className="empty-state">
            <p>No notes created yet. Add your first note!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotesManager;
